<template lang="pug">
  section.video-player(:class="getActiveDecade.orientation")
    .wrap
      .video-wrapper
        d-player(@play="play", :options="options" ref="player")
      .video-text
        transition(name="entrytext")
          TheText(:thetext="musicgenre" :loading="videoloading")
        .sharer
          Sharer
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import VueDPlayer from 'vue-dplayer'
  import TheText from '@/components/timeline/TheText'
  import Sharer from '@/components/timeline/Sharer'
  import 'vue-dplayer/dist/vue-dplayer.css'

  export default {
    name: 'video-player',
    components: {
      'd-player': VueDPlayer,
      TheText,
      Sharer
    },
    data() {
      return {
        player: null,
        options: {
          loop: true,
          preload: true
        },
        musicgenre: '',
        videoloading: false
      }
    },
    mounted() {
      this.player = this.$refs.player.dp
      this.setPlayer(this.$refs.player.dp)
      this.videoloading = true
      this.playTransition()
      setTimeout(() => {
        this.decadeData()
        this.videoloading = false
      }, 3000)
    },
    watch: {
      getActiveDecade(dec){
        this.decadeData(dec)
      },
      getVideoNotifier(){
        this.videoloading = true
        setTimeout(() => {
          this.player.play()
          this.videoloading = false
        }, 300)
      }
    },
    methods: {
      play() {
      },
      getRandSeek(){
        return Math.floor(Math.random() * 5) + 1
      },
      decadeData(dec = this.getActiveDecade, order = 0){
        this.videoloading = true
        const video = dec.videos[order]
        this.playTransition()
        setTimeout(() => {
          this.player.switchVideo({
            url: video.musicurl,
            pic: video.musicposter
          })
          this.player.seek(video.seek)
          this.musicgenre = video.musicgenre
          this.videoloading = false
          this.player.play()
        }, 1000)
      },
      playTransition(){
        this.player.switchVideo({
          url: 'assets/videos/transition.mp4'
        })
        const randseek = this.getRandSeek();
        this.player.seek(randseek)
        this.player.play()
      },
      ...mapActions([
        'setPlayer'
      ]),
    },
    computed: {
      ...mapGetters([
        'getActiveDecade',
        'getVideoNotifier',
        'getPlayer'
      ]),
    }
}
</script>

<style lang="scss">
  .video-player{
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    width: 100%;
    padding-top: 1rem;
    height: calc(100vh - 112px - 51px);
    &.right{
      justify-content: flex-start;
    }
    @media screen and (max-width: 900px){
      height: auto;
      display: block;
    }
  }

  .wrap{
    padding: 0 3rem;
    position: relative;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    @media screen and (max-width: 900px){
      width: 100%;
      padding: 0 1rem;
    }
  }
  .video-wrapper{
    @media screen and (max-width: 600px){
      width: 100%;
    }
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to{
    transform: translateX(60px);
    opacity: 0;
  }

  .sharer{
    position: fixed;
    bottom: 1rem;
    right: 3rem;
    @media screen and (max-width: 900px){
      right: 1rem;
    }
  }


</style>
